class LanguageSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.els.select.element.addEventListener(
      'change',
      this.onSelectChange.bind(this),
    )
  }

  onSelectChange () {
    const selectedOption =
      this.els.select.element.options[this.els.select.element.selectedIndex]
    const selectedFlag = selectedOption.dataset.image

    const selectedValue = selectedOption.value

    const selectedText = selectedOption.textContent
    let newURL = `/${selectedValue}`

    if (selectedValue === 'en') {
      newURL = '/'
    }

    this.els.flag.element.src = selectedFlag
    this.els.flag.element.alt = selectedText
    this.els.name.element.textContent = selectedText

    this.els.url.element.href = newURL
  }
}

if (!customElements.get('language-switcher')) {
  customElements.define('language-switcher', LanguageSwitcher)
}
